<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">Add Entry</h4>
                </div>
                <div class="modal-body">
                    <!-- ___ Date To ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Date To</label>
                        </div>
                        <div class="col-md-8 inlineDateAndTime">
                            <mat-form-field>
                                <input matInput [(ngModel)]="date" name="date"
                                       (focus)="picker.open()" (click)="picker.open()"
                                       [matDatepicker]="picker" placeholder="Choose a date" required>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                            <div class="input-group bootstrap-timepicker timepicker" (click)="openTimepicker()">
                                <input id="timepicker1"
                                       class="form-control input-small"
                                       name="time"
                                       [ngModel]="time" required>
                                <span class="input-group-addon">
                                    <i class="glyphicon glyphicon-time"></i>
                                </span>
                            </div>
                        </div>
                    </div>

                    <!-- ___ Details  ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Details</label>
                        </div>
                        <div class="col-md-8">
                            <textarea class="form-control" name="details" [ngModel]="data.details" required></textarea>
                        </div>
                    </div>

                    <div class="row text-center space-30">
                        <button type="submit" class="btn btn-primary submit-btn" [disabled]="disabledSubmit">Save</button>
                    </div>

                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/daily-reports/daily-reports-add-entry-modal/daily-reports-add-entry-modal.component.html